<!-- Data Table options
-- https://www.npmjs.com/package/angular2-datatable npm i -S angular2-datatable
-- http://www.primefaces.org/primeng/#/
	
	
	To switch back to scrollable from pagination, here are the required options.
	scrollable="true" scrollHeight="1000px" 
-->

<div id="topHeader">
<h2>Station Summary</h2>
{{numStations}} stations displayed.
</div>

<div style="clear:both">

<!-- header -->
<!-- <p-table #dt [value]="stationsArray" [scrollable]="true" scrollHeight="800px" [columns]="cols"> -->
<p-table #dt [value]="stationsArray" [scrollable]="true" scrollHeight={{scrollHeight}} [columns]="cols">
	<!-- search filter -->
	<ng-template pTemplate="caption">
		<div style="text-align: right">        
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Search for ID or Name" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
	</ng-template>
	<!-- 

	<ng-template pTemplate="colgroup">
		<colgroup>
			<col>
			<col style="width:180px">  < !-- name -- >
			<col>
			<col style="width:150px"> < !-- dataType -- >
			<col>
			<col>
			<col>
			<col>
			<col>
			<col>
			< !-- <col> flood threat -- >
			<col>
			<col>
			<col>
		</colgroup>
	</ng-template>

	-->

	<ng-template pTemplate="header">
		<tr>
			<th colspan="3">Station Data</th>
			<th></th>
			<th colspan="4">Observations<img src="assets/images/question-mark-icon.gif" title="{{this.dataTypeDescription}}"></th>
			<th colspan="2">Current Status</th>  <!-- change back to 3 if flood threat is included again -->
			<th colspan="3">Forecast</th>
		</tr>
		<tr>
			<th>
				<div class="multiLineElements">
				<label>ID</label>
				<input type="button" class="sortUpButton" (click)="sortById(1)" title="Sort ascending by id" />
				<input type="button" class="sortDownButton" (click)="sortById(-1)" title="Sort descending by id" />
				</div>
			</th>
			<th>
				<div class="multiLineElements">
				<label>Name</label>
				<input type="button" class="sortUpButton" (click)="sortByName(1)" title="Sort ascending by name" />
				<input type="button" class="sortDownButton" (click)="sortByName(-1)" title="Sort descending by name" />
				</div>
			</th>
			<th>Basin</th>
			<!-- <th [style]="{'overflow':'visible'}">Data Type<br>(sort by)<br> -->
			<!-- <th style="overflow:visible"> -->
			<th>
				<div class="multiLineElements">
				<label>Data Type</label>
				<label>(sort by)</label>
				<p-select [options]="sortTypeList" [(ngModel)]="sortType" appendTo="body" [style]="{'min-width': '6em', 'width':'120px', 'overflow':'visible'}" [dropdownIcon]="caret"
					(ngModelChange)="newSortDataTypeSelected($event)" title="Data type on which to sort when sort buttons to the right are clicked (Last Week through Last 15 Minutes)">
					<ng-template let-sortType pTemplate="item">
						<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
	            			<div>{{sortType.label}}</div>
	        			</div>
					</ng-template>
				</p-select>
				</div>
			</th>
			<th id="lastWeekColumn">
				<div class="multiLineElements">
				<label>Last Week</label>
				<input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('lastWeek', 1)" title="Sort ascending by selected data type ({{sortType}})" />
				<input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('lastWeek', -1)" title="Sort descending by selected data type ({{sortType}})" />
				</div>
			</th>
			<th>
				<div class="multiLineElements">
				<label>Last Day</label>
				<input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('lastDay', 1)" title="Sort ascending by selected data type ({{sortType}})" />
				<input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('lastDay', -1)" title="Sort descending by selected data type ({{sortType}})" />
				</div>
			</th>
			<th>
				<div class="multiLineElements">
				<label>Last 3 Hours</label>
				<input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('last3Hours', 1)" title="Sort ascending by selected data type ({{sortType}})" />
				<input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('last3Hours', -1)" title="Sort descending by selected data type ({{sortType}})" />
				</div>
			</th>
			<th>
				<div class="multiLineElements">
				<label>Last Hour</label>
				<input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('lastHour', 1)" title="Sort ascending by selected data type ({{sortType}})" />
				<input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('lastHour', -1)" title="Sort descending by selected data type ({{sortType}})" />
				</div>
			</th>
			<th>
				<div class="multiLineElements">
				<label>Last 15 Mins</label>
				<input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('last15Minutes', 1)" title="Sort ascending by selected data type ({{sortType}})" />
				<input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('last15Minutes', -1)" title="Sort descending by selected data type ({{sortType}})" />
				</div>
			</th>
			<th>
				<div class="multiLineElements">
					<label>Alarm Status</label>
					<input type="button" class="sortDownButton" (click)="sortByAlarm(-1)" title="Sort descending by alarm" />
				</div>
			</th>
			<!--
			<th>Flood Threat<br><input type="button" class="sortDownButton" (click)="sortByThreat()" title="Sort descending by flood threat based on rain nova score" />
			</th>
			-->
			<th>Today</th>
			<th>Tomorrow</th>
			<th>Next Week</th>
		</tr>
		<tr>
			<!-- <th colspan="3"></th> -->
			<th></th>
			<th></th>
			<th></th>
			<th>Weather</th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.lastWeek}} title={{this.weatherInfo.lastWeekMsg}} class="weatherImage"></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.lastDay}} title={{this.weatherInfo.lastDayMsg}} class="weatherImage"></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.last3Hours}} title={{this.weatherInfo.last3HoursMsg}} class="weatherImage"></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.lastHour}} title={{this.weatherInfo.lastHourMsg}} class="weatherImage"></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.last15Minutes}} title={{this.weatherInfo.last15MinutesMsg}} class="weatherImage"></a></th>	
			<th></th>
			<!-- <th></th> flood threat -->
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.next6Hours}} title={{this.weatherInfo.next6HoursMsg}} class="weatherImage"></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.nextDay}} title={{this.weatherInfo.nextDayMsg}} class="weatherImage"></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.nextWeek}} title={{this.weatherInfo.nextWeekMsg}} class="weatherImage"></a></th>
		</tr>
	</ng-template>
//
// data
//
	<ng-template pTemplate="body" let-rowData>
    
	<tr>
		<!-- ID -->
		<td>{{rowData.id}}</td>
		<!-- Name -->
    	<td>{{rowData.name}}</td>
		<!-- Basin -->
		<td></td>
	    <!-- Data Type -->
		<td>
		<!-- 	<td [style]="{'width':'150px'}">  -->
			<div class="multiLineData">
			<span *ngIf="rowData['hasData'].rain == true" [ngClass]="rowData.alarmStatus.rainNovaScoreClass">Rain (in)</span>
			<span *ngIf="rowData['hasData'].waterLevel == true" [ngClass]="rowData.alarmStatus.waterLevelNovaScoreClass">Water Level (ft)</span>
			<span *ngIf="rowData['hasData'].streamflow == true" [ngClass]="rowData.alarmStatus.streamflowNovaScoreClass">Streamflow (cfs)</span>
			<span *ngIf="rowData['hasData'].wind == true" [ngClass]="rowData.alarmStatus.windNovaScoreClass">Wind (mph)</span>
			</div>
		</td>
		<!-- Last Week -->
		<td> 
			<div class="multiLineData">
			<!--  This was working when each station had individual weather data
			<span class="top-line"><img  *ngIf="dat[col.field].weather < 10" src="images/clear.gif">   
					<img  *ngIf="dat[col.field].weather >= 10 && dat[col.field].weather < 20" src="images/partlycloudy.gif">
					<img  *ngIf="dat[col.field].weather >= 20 && dat[col.field].weather < 30" src="images/mostlycloudy.gif">
					<img  *ngIf="dat[col.field].weather >= 30" src="images/rain.gif"> </span><hr>
			-->
			<span *ngIf="rowData.hasData.rain == true" class="numbers">{{rowData.lastWeek.rain}}</span>
			<span *ngIf="rowData.hasData.waterLevel == true" class="numbers">{{rowData.lastWeek.waterLevel}}</span>
			<span *ngIf="rowData.hasData.streamflow == true" class="numbers">{{rowData.lastWeek.streamflow}}</span>
			<span *ngIf="rowData.hasData.wind == true" class="numbers">{{rowData.lastWeek.wind}}</span>
			</div>
		</td>		
		<!-- Last Day -->		
		<td>
			<div class="multiLineData">
			<span *ngIf="rowData.hasData.rain == true" class="numbers">{{rowData.lastDay.rain}}</span>
			<span *ngIf="rowData.hasData.waterLevel == true" class="numbers">{{rowData.lastDay.waterLevel}}</span>
			<span *ngIf="rowData.hasData.streamflow == true" class="numbers">{{rowData.lastDay.streamflow}}</span>
			<span *ngIf="rowData.hasData.wind == true" class="numbers">{{rowData.lastDay.wind}}</span>
			</div>
		</td>	
		<!-- Last 3 Hours -->		
		<td>
			<div class="multiLineData">
			<span *ngIf="rowData.hasData.rain == true" class="numbers">{{rowData.last3Hours.rain}}</span>
			<span *ngIf="rowData.hasData.waterLevel == true" class="numbers">{{rowData.last3Hours.waterLevel}}</span>
			<span *ngIf="rowData.hasData.streamflow == true" class="numbers">{{rowData.last3Hours.streamflow}}</span>
			<span *ngIf="rowData.hasData.wind == true" class="numbers">{{rowData.last3Hours.wind}}</span>
			</div>
		</td>	
		<!-- Last Hour -->		
		<td>
			<div class="multiLineData">
			<span *ngIf="rowData.hasData.rain == true" class="numbers">{{rowData.lastHour.rain}}</span>
			<span *ngIf="rowData.hasData.waterLevel == true" class="numbers">{{rowData.lastHour.waterLevel}}</span>
			<span *ngIf="rowData.hasData.streamflow == true" class="numbers">{{rowData.lastHour.streamflow}}</span>
			<span *ngIf="rowData.hasData.wind == true" class="numbers">{{rowData.lastHour.wind}}</span>
			</div>
		</td>	
		<!-- Last 15 Mins -->		
		<td class="headerBackground">	
			<div class="multiLineData">
			<span *ngIf="rowData['hasData'].rain == true" class="numbers" [ngClass]="rowData.alarmStatus.rainNovaScoreClass">{{rowData.last15Minutes.rain}}</span>
			<span *ngIf="rowData['hasData'].waterLevel == true" class="numbers" [ngClass]="rowData.alarmStatus.waterLevelNovaScoreClass">{{rowData.last15Minutes.waterLevel}}</span>
			<span *ngIf="rowData['hasData'].streamflow == true" class="numbers" [ngClass]="rowData.alarmStatus.streamflowNovaScoreClass">{{rowData.last15Minutes.streamflow}}</span>
			<span *ngIf="rowData['hasData'].wind == true" class="numbers" [ngClass]="rowData.alarmStatus.windNovaScoreClass">{{rowData.last15Minutes.wind}}</span>
			</div>
		</td>	
		<!-- Alarm Status -->		
		<td class="headerBackground">	
			<span class="table-data">
				<!--
			<tr><td><span *ngIf="rowData['hasData'].rain == true" [ngClass]="rowData.alarmStatus.rainclass">{{rowData.alarmStatus.rain}}</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].waterLevel == true" [ngClass]="rowData.alarmStatus.waterLevelclass">
				<img src="assets/images/alarm-bell-large.gif" class="table-icon" title={{rowData.alarmStatus.waterLevel}}>
			</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].streamflow == true" [ngClass]="rowData.alarmStatus.streamflowclass">{{rowData.alarmStatus.streamflow}}</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].wind == true" [ngClass]="rowData.alarmStatus.windclass">{{rowData.alarmStatus.wind}}</span></td></tr>
				-->
				<span *ngIf="rowData.alarmStatus.alarmsMessage != ''"><img src="assets/images/alarm-bell-large.gif" class="table-icon" title={{rowData.alarmStatus.alarmsMessage}}> 
				</span>
			</span>
		</td>	
		<!-- Flood Threat -->		
		<!--
		<td class="headerBackground">
			<span class="table-data alarm">  
		-->
				<!-- if criteria changes here, modify sort criteria in station-table.component.ts -->
				<!--  taking out entirely for now until we figure out how to tie this together with elevation
			<img *ngIf="rowData.alarmStatus.rainNovaScore >= 3 || rowData.alarmStatus.waterLevelNovaScore >= 3 || rowData.alarmStatus.streamflowNovaScore >= 3" height="64px" width="64px" src="assets/images/severeFloodWarning.gif"> 
				-->
				<!--

			</span>
		</td>	
				-->
		<!-- Next 6 Hours -->		
		<td>	
			<span class="numbers">{{this.weatherInfo.next6HoursPrecipProbability}}%</span>
		</td>	
		<!-- Next Day -->		
		<td>
			<span class='numbers'>{{this.weatherInfo.nextDayPrecipProbability}}%</span>
		</td>	
		<!-- Next Week -->		
		<td>
			<span class="numbers">{{this.weatherInfo.nextWeekPrecipProbability}}%</span>
			<!-- to hide a line:
				<span style="visibility: hidden">empty</span> -->
		</td>		
	</tr>
	</ng-template>
</p-table>
</div>
